import $ from 'jquery'

class PlayVideo {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables
		this.events()
	}

	//?events
	events() {
		let myObj = this

		if (window.innerWidth > 765) {
			myObj.PlayVideoFunction()
		} else {
			// do nothing
		}
	}

	//? 3. methods (functions)
	PlayVideoFunction() {
		console.log('Hello dude')
		var vid = document.getElementById('KibsiVideo')
		var controller = new ScrollMagic.Controller()
		let isPlaying = false

		function ToggleVideo() {
			console.log('njfkbsakj')

			if (!isPlaying) {
				console.log('play')
				vid.play()
				isPlaying = true
			} else {
				vid.pause()
				isPlaying = false
			}
		}
		var Typescene = new ScrollMagic.Scene({
			triggerElement: '#KibsiVideo',
			offset: -400,
			duration: window.innerHeight * 1.3,
		})
			.addTo(controller)
			// .addIndicators() // add indicators (requires plugin)
			.on('update', function (e) {
				console.log('update')
			})
			.on('enter leave', function (e) {
				ToggleVideo()
			})
		// .on('start end', function (e) {
		// 	console.log('start end')
		// })
		// .on('progress', function (e) {
		// 	console.log('progress')
		// })
	}
}

export default PlayVideo
